import React from 'react';

import T from '@prisjakt/ui-translate';
import DataContainer from '../../../../components/data';
import Loader from '../../../../components/loader';
import PriceHistoryFragment from '../../../product/components/price-history/fragment.graphql';
import CreateAlert from '../create-alert';

import * as S from './styles';

const alertFragment = `
fragment alert on Product {
  alert {
    id
    priceThreshold
    alertType
    priceStep
    storePreference
    storeGradeThreshold
  }
}
`;

const productQuery = `query($id: Int!, $statisticsTime: String) {
  product(id: $id) {
    ...priceHistory
    ...alert
  }
} ${PriceHistoryFragment} ${alertFragment}`;

const ProductAlertModalContent = props => {
  const { product, withoutGraph, close, privacyPolicyUri } = props;

  return (
    <DataContainer
      query={productQuery}
      renderLoader={() => <Loader fadeIn />}
      variables={{ id: product.id }}
      render={({ data }) => {
        const productData = {
          ...product,
          ...data.product,
        };
        const isEdit = !!(productData.alert && productData.alert.id);

        return (
          <S.Wrapper>
            <h2>
              {isEdit ? (
                <T domain="product">alert.title-edit</T>
              ) : (
                <T domain="product">alert.title</T>
              )}
            </h2>
            <div>
              <p>
                <T domain="product">alert.lead-text</T>
              </p>
              <CreateAlert
                withoutGraph={withoutGraph}
                product={productData}
                showCancel={false}
                onCreate={close}
                onRemove={close}
                privacyPolicyUri={privacyPolicyUri}
              />
            </div>
          </S.Wrapper>
        );
      }}
    />
  );
};

export default ProductAlertModalContent;
